import { Spinner } from 'components/core';
import React, { ReactElement } from 'react';
import { useProcesses } from 'store/process';

export const withProcessesData =
  (Component: React.ComponentType<any>) =>
  ({ ...props }): ReactElement => (
    <WithProcessesData>
      <Component {...props} />
    </WithProcessesData>
  );

interface WithProcessesDataType { children: ReactElement }

function WithProcessesData({
  children,
}: WithProcessesDataType): ReactElement {
  const { loading, isReady } = useProcesses();

  if (loading || !isReady) {
    return <Spinner reason={`processes not ready: ${isReady}`} />;
  }

  return children;
}
